import { render, staticRenderFns } from "./HistoricMirrorTable.vue?vue&type=template&id=5ef125d8&scoped=true&"
import script from "./HistoricMirrorTable.vue?vue&type=script&lang=js&"
export * from "./HistoricMirrorTable.vue?vue&type=script&lang=js&"
import style0 from "./HistoricMirrorTable.vue?vue&type=style&index=0&id=5ef125d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef125d8",
  null
  
)

export default component.exports